'use client';
import React from 'react';

type SelectableLabelTilesState = "normal" | "selected" | "disabled";

interface SelectableLabelTilesProps {
	label: string
	text: string
	disabled?: boolean
	onClick?: () => void
	isSelected?: boolean
}

const STATE_TO_BG: Record<SelectableLabelTilesState, string> = {
	normal: `
		bg-bg-light-tertiary
		hover:bg-bg-light-quinary
	`,
	selected: `
		bg-theme-yellow-primary-base
	`,
	disabled: `
		bg-bg-disabled
	`,
}


const STATE_TO_BORDER: Record<SelectableLabelTilesState, string> = {
	normal: `
		outline-stroke-soft-200
	`,
	selected: `
		outline-theme-yellow-primary-base
	`,
	disabled: `
		outline-stroke-disabled
	`,
}


const STATE_TO_LABEL_TEXT: Record<SelectableLabelTilesState, string> = {
	normal: `
		text-text-quinary
	`,
	selected: `
		text-text-reversed
	`,
	disabled: `
		text-text-disabled
	`,
}

const STATE_TO_TEXT: Record<SelectableLabelTilesState, string> = {
	normal: `
		text-text-primary
		group-hover:text-text-quaternary
	`,
	selected: `
		text-text-primary
	`,
	disabled: `
		text-text-disabled
	`,
}

const getState = (disabled: boolean, selected: boolean): SelectableLabelTilesState => {
	if (disabled) return "disabled";
	if (selected) return "selected";

	return "normal";
}



const SelectableLabelTiles: React.FC<SelectableLabelTilesProps> = ({
	label,
	text,
	disabled = false,
	onClick = () => { },
	isSelected = false
}) => {

	return (
		<button
			onClick={onClick}
			className={`
				outline-main
				w-full
				${STATE_TO_BG[getState(disabled, isSelected)]}
				${STATE_TO_BORDER[getState(disabled, isSelected)]}
				rounded-[16px]
			
				transition-colors duration-500 ease-[ease]

				cursor-pointer
				disabled:cursor-not-allowed

				group
			`}
		>
			<p className={`
				px-[2rem] py-[0.75rem]

				${STATE_TO_LABEL_TEXT[getState(disabled, isSelected)]}				

				text-12--wide--alexandria

				text-center
				`}>
				{label}
			</p>
			<div className={`
				bg-bg-light-primary

				outline-main 
				${STATE_TO_BORDER[getState(disabled, isSelected)]}
				rounded-[16px]

				px-[1.5rem] py-[1.25rem]
				lg:px-[2rem] lg:py-[1.5rem]


				${STATE_TO_TEXT[getState(disabled, isSelected)]}				

				text-18--alexandria

				text-center
				`}>
				{text}
			</div>
		</button>
	);
}

export default SelectableLabelTiles;
